// Tutto il contenuto demo è qui: modifica numeri, indirizzi, prezzi e testi in un unico punto.
// Prezzi in CHF · Demo per la Svizzera.
const img = (id, w = 1200) =>
    `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const salone = {
    brand: "Salone Demo",
    eyebrow: "Haute Coiffure · Zürich",
    slogan: "L'arte della bellezza sartoriale",
    description:
        "Da oltre 15 anni ridefiniamo il concetto di hair styling d'eccellenza. Tagli scultorei, tecniche balayage esclusive e trattamenti rigeneranti in una cornice di assoluto relax.",
    titolare: { name: "Mario Rossi", role: "Titolare & Hair Stylist Director" },
    contacts: {
        phone: "+390510420087",
        phoneRaw: "+390510420087",
        address: "Bahnhofstrasse 12, 8001 Zürich",
        email: "info@salonedemo.ch",
        whatsapp: "+390510420087",
        whatsappRaw: "+390510420087",
        mapQuery: "Bahnhofstrasse 12, 8001 Zürich",
    },
    orari: [
        { days: "Martedì — Giovedì", hours: "09:30 – 19:30" },
        { days: "Venerdì — Sabato", hours: "09:00 – 20:00" },
        { days: "Domenica — Lunedì", hours: "Chiuso" },
    ],
    heroImage: img("1675034743339-0b0747047727", 1600),
    gallery: [
        { src: img("1554519934-e32b1629d9ee", 900), title: "Balayage Biondo Mielato", tag: "Colore & Riflessi" },
        { src: img("1629397685944-7073f5589754", 900), title: "Piega Onde Red Carpet", tag: "Styling & Eventi" },
        { src: img("1560869713-7d0a29430803", 900), title: "Definizione Riccio & Trattamento", tag: "Cura del Capello" },
        { src: img("1759134198561-e2041049419c", 900), title: "Taglio Sartoriale Maschile", tag: "Gentleman Barber" },
        { src: img("1781455793310-8427c96454c7", 900), title: "Atelier Privato", tag: "Design & Relax" },
        { src: img("1790009419892-f6f3fd516fb2", 900), title: "Postazione VIP", tag: "Exclusive Treatment" },
        { src: img("1711274094763-ff442e4719ef", 900), title: "Taglio di Precisione", tag: "A Forbice" },
        { src: img("1593702288056-7927b442d0fa", 900), title: "Barba & Rasoio", tag: "Barber Ritual" },
    ],
    priceList: [
        { name: "Taglio & Styling Donna", price: "CHF 45.–", details: "Consulenza morfologica, shampoo trattante, taglio sartoriale e finish luxury" },
        { name: "Taglio Uomo & Barba Ritual", price: "CHF 38.–", details: "Modellatura barba con panno caldo agli oli essenziali e taglio sfumato a forbice" },
        { name: "Piega Glamour & Trattamento Gloss", price: "CHF 28.–", details: "Piega a phon/ferro con fissativo idratante a lunga durata" },
        { name: "Colore Sartoriale & Balayage", price: "CHF 75.–", details: "Schiariture naturali a mano libera, tonalizzazione personalizzata anti-giallo" },
        { name: "Trattamento Botox & Cheratina Pura", price: "CHF 60.–", details: "Rigenerazione profonda del fusto, rimpolpante alla cheratina vegetale" },
        { name: "Barba Express con Rifinitura", price: "CHF 22.–", details: "Trattamento rapido con allume di rocca e balsamo idratante artigianale" },
    ],
    reviews: [
        { author: "Chiara Valenti", rating: 5, service: "Balayage & Taglio", quote: "Mario è un vero maestro. Il colore è luminoso, naturale e non rovina i capelli. L'atmosfera del salone è intima ed elegantissima." },
        { author: "Alessandro Moretti", rating: 5, service: "Barba Ritual & Taglio Uomo", quote: "La migliore barba di Zurigo. Il panno caldo e la cura per i dettagli mi hanno conquistato subito. Puntualità impeccabile." },
        { author: "Elena Ferrante", rating: 5, service: "Trattamento Botox Capelli", quote: "Ho provato il trattamento Botox dopo l'estate: i capelli sono tornati setosi e corposi come mai prima. Consigliatissimo!" },
    ],
    socials: [
        { platform: "Instagram", handle: "@salonedemo_zurich", url: "https://instagram.com" },
        { platform: "Facebook", handle: "Salone Demo Zürich", url: "https://facebook.com" },
        { platform: "TikTok", handle: "@salonedemo_official", url: "https://tiktok.com" },
    ],
    marquee: ["Taglio Sartoriale", "Balayage", "Barba Ritual", "Trattamenti Rigeneranti", "Piega Glamour", "Aperto Mar — Sab"],
};

export const pizzeria = {
    brand: "Pizzeria Demo",
    eyebrow: "Forno a Legna · Lugano",
    slogan: "La vera pizza napoletana a lenta lievitazione",
    description:
        "72 ore di maturazione naturale, farina macinata a pietra, pomodoro San Marzano DOP e fior di latte di Agerola. Portiamo in tavola l'autentica convivialità della cucina italiana.",
    titolare: { name: "Gennaro Esposito", role: "Mastro Pizzaiolo & Titolare" },
    contacts: {
        phone: "+4932221092873",
        phoneRaw: "+4932221092873",
        address: "Via Nassa 10, 6900 Lugano",
        email: "tavoli@pizzeriademo.ch",
        whatsapp: "+4932221092873",
        whatsappRaw: "+4932221092873",
        mapQuery: "Via Nassa 10, 6900 Lugano",
    },
    orari: [
        { days: "Martedì — Venerdì", hours: "12:00 – 15:00 · 19:00 – 23:30" },
        { days: "Sabato — Domenica", hours: "12:00 – 15:30 · 19:00 – 00:00" },
        { days: "Lunedì", hours: "Chiuso" },
    ],
    heroImage: img("1788603092447-82fea3466430", 1600),
    gallery: [
        { src: img("1788603092447-82fea3466430", 900), title: "Pizza Don Raffaele", tag: "Burrata Pugliese" },
        { src: img("1788603092393-bfcdfd2257f7", 900), title: "Pizza Verde Vesuvio", tag: "Pesto & Zucchine" },
        { src: img("1599984615649-3307ec0ef478", 900), title: "Tagliolini al Tartufo", tag: "Primi di Tradizione" },
        { src: img("1532117472055-4d0734b51f31", 900), title: "Spaghetti alle Vongole", tag: "Primi di Mare" },
        { src: img("1732869931523-8fd0437da0f1", 900), title: "Tiramisù al Mascarpone", tag: "Dolci della Casa" },
        { src: img("1563245738-9169ff58eccf", 900), title: "Forno a Legna", tag: "Pizze d'Autore" },
        { src: img("1691067987594-b1b7f84ba55a", 900), title: "La Sala", tag: "Calore di Trattoria" },
        { src: img("1767713362918-1318f64b128a", 900), title: "La nostra Insegna", tag: "Cuore di Lugano" },
    ],
    menu: [
        {
            name: "Antipasti",
            items: [
                { name: "Crocchè Napoletano Tradizionale", price: "CHF 3.50", desc: "Patate a pasta gialla, provola affumicata campana, prezzemolo fresco e pepe" },
                { name: "Montanara Fritta", price: "CHF 4.50", desc: "Pizzetta fritta dorata, passata di pomodoro San Marzano e Parmigiano" },
                { name: "Frittatina di Pasta Classica", price: "CHF 4.00", desc: "Bucatini con besciamella rustica, piselli fini novelli e dadini di fior di latte" },
            ],
        },
        {
            name: "Pizze",
            items: [
                { name: "Margherita Verace DOP", price: "CHF 8.50", desc: "Pomodoro San Marzano DOP, mozzarella di bufala campana, basilico, olio EVO" },
                { name: "Marinara dell'Alleanza", price: "CHF 7.00", desc: "Pomodoro antico di Napoli, aglio rosso di Nubia, origano dei monti e olio EVO" },
                { name: "Don Raffaele · Burrata", price: "CHF 12.50", desc: "Fior di latte, pesto di basilico genovese, pomodorini confit e burrata intera 125g" },
                { name: "Diavola Saporita", price: "CHF 10.00", desc: "Pomodoro San Marzano, fior di latte, salamino piccante napoletano e peperoncino" },
            ],
        },
        {
            name: "Primi",
            items: [
                { name: "Paccheri di Gragnano alla Sorrentina", price: "CHF 11.50", desc: "Gratinati nel forno a legna con pomodoro fresco, provola filante e basilico" },
                { name: "Spaghettoni alle Vongole Veraci", price: "CHF 15.00", desc: "Vongole fresche tirate al vino Falanghina, aglio dorato e prezzemolo" },
            ],
        },
        {
            name: "Secondi",
            items: [
                { name: "Parmigiana di Melanzane", price: "CHF 10.50", desc: "Cotta al tegame di terracotta con fior di latte asciutto e riduzione di pomodoro" },
                { name: "Polpette della Nonna", price: "CHF 12.00", desc: "Tre polpette di manzo e maiale cotte 6 ore nel ragù napoletano tradizionale" },
            ],
        },
        {
            name: "Dolci",
            items: [
                { name: "Tiramisù al Mascarpone", price: "CHF 6.00", desc: "Savoiardi bagnati nel caffè espresso napoletano e crema al mascarpone vellutata" },
                { name: "Babà al Rum Invecchiato", price: "CHF 5.50", desc: "Pasta lievitata morbidissima bagnata al rum con ciuffo di panna fresca" },
            ],
        },
        {
            name: "Bevande",
            items: [
                { name: "Birra Artigianale Partenopea · 0.33L", price: "CHF 5.00", desc: "Bionda non filtrata ad alta fermentazione con note di cereali" },
                { name: "Calice Aglianico del Sannio DOC", price: "CHF 4.50", desc: "Rosso strutturato campano con sentori di mora e vaniglia" },
                { name: "Acqua Minerale · 0.75L", price: "CHF 2.50", desc: "Naturale o frizzante, in bottiglia di vetro" },
            ],
        },
    ],
    reviews: [
        { author: "Marco Benetti", rating: 5, service: "Cena in Trattoria", quote: "Cornicione alto, alveolatura perfetta e ingredienti freschissimi. La Don Raffaele con burrata è indimenticabile!" },
        { author: "Sofia De Luca", rating: 5, service: "Tavolo per 4 persone", quote: "Si respira l'atmosfera delle vere trattorie di quartiere. Servizio caloroso, babà spettacolare e prezzi onestissimi." },
        { author: "Daniele Rossi", rating: 5, service: "Degustazione Pizze", quote: "Pizza digeribilissima anche la sera tardi. Personale gentile e professionale. Prenotare è consigliatissimo!" },
    ],
    socials: [
        { platform: "Instagram", handle: "@pizzeriademo_lugano", url: "https://instagram.com" },
        { platform: "Facebook", handle: "Pizzeria Demo Lugano", url: "https://facebook.com" },
        { platform: "TikTok", handle: "@pizzeriademo_forno", url: "https://tiktok.com" },
    ],
    marquee: ["Forno a Legna", "Lievitazione 72 Ore", "San Marzano DOP", "Impasto Artigianale", "La Tradizione Napoletana"],
};

export const hub = {
    marquee: ["Siti Web Professionali", "Parrucchieri", "Pizzerie & Ristoranti", "Prenotazione Telefonica", "Contatti & Mappe", "Demo Commerciale"],
    cards: [
        {
            title: "Salone & Barberia Demo",
            badge: "Lusso & Moda",
            icon: "scissors",
            description: "Atelier di bellezza, listino servizi, gallery e prenotazione rapida via telefono.",
            action: "Esplora il Salone",
            bg: img("1759134198561-e2041049419c", 1400),
            to: "/salone",
        },
        {
            title: "Pizzeria & Trattoria Demo",
            badge: "Food & Osteria",
            icon: "pizza",
            description: "Cucina artigianale, menù completo con prezzi, recensioni e riserva tavolo.",
            action: "Esplora la Pizzeria",
            bg: img("1593548615309-5a45c504f994", 1400),
            to: "/pizzeria",
        },
    ],
};
